import { freightDeliveryAccessorialPresetIdFormat } from "@redotech/redo-fulfillment-id";
import * as z from "zod";

export const setDefaultFreightDeliveryAccessorialPreset = {
  name: "setDefaultFreightDeliveryAccessorialPreset" as const,
  input: z.object({ id: freightDeliveryAccessorialPresetIdFormat.schema }),
  output: z.object({}),
};
